import React from 'react'
import { Shield, Lock, AlertTriangle } from 'lucide-react'

interface AccessDeniedProps {
  message?: string
  title?: string
  icon?: 'shield' | 'lock' | 'warning'
  showBackButton?: boolean
  onBack?: () => void
}

export default function AccessDenied({
  message = "You don't have permission to access this feature.",
  title = 'Access denied',
  icon = 'shield',
  showBackButton = true,
  onBack,
}: AccessDeniedProps) {
  const getIcon = () => {
    switch (icon) {
      case 'lock':
        return <Lock className="mx-auto mb-4 h-16 w-16 text-red-300" />
      case 'warning':
        return <AlertTriangle className="mx-auto mb-4 h-16 w-16 text-amber-300" />
      default:
        return <Shield className="mx-auto mb-4 h-16 w-16 text-red-300" />
    }
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-5 py-20">
      <div className="salt-glass-light max-w-md w-full rounded-3xl p-10 text-center">
        {getIcon()}
        <h1 className="font-display text-2xl font-semibold text-white">{title}</h1>
        <p className="mt-2 text-sm text-white/45">{message}</p>
        {showBackButton && (
          <button
            type="button"
            onClick={onBack || (() => window.history.back())}
            className="salt-cta-mega mt-8 !py-2.5 !px-6 !text-sm"
          >
            Go back
          </button>
        )}
      </div>
    </div>
  )
}
